import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";

const SECTIONS = [
  {
    title: "Éditeur du site",
    content: [
      "Ent. Goujon Vallée (SAS GV) — Couverture, Charpente, Bardage, Ossature Bois, Isolation",
      "330 rue de l'Avenir, 27310 Bosgouet — Normandie, France",
      "Téléphone : 02 35 60 36 33",
      "Email : contact@goujonvallee.fr",
      "SIRET : 880 344 122 00036 — RCS : 880 344 122 R.C.S. Bernay",
      "Directeur de la publication : le représentant légal de la société Goujon Vallée",
    ],
  },
  {
    title: "Hébergement",
    content: [
      "Ce site est hébergé sur une infrastructure cloud sécurisée. Les données sont hébergées au sein de l'Union européenne.",
    ],
  },
  {
    title: "Propriété intellectuelle",
    content: [
      "L'ensemble du contenu de ce site (textes, photographies de chantiers, logo, charte graphique) est la propriété exclusive de l'entreprise Goujon Vallée, sauf mention contraire.",
      "Les photographies de réalisations proviennent du compte Instagram officiel @goujon_vallee. Toute reproduction sans autorisation écrite est interdite.",
    ],
  },
  {
    title: "Protection des données (RGPD)",
    content: [
      "Les informations transmises via le formulaire de devis (nom, téléphone, email, commune, description du projet) servent uniquement à traiter votre demande et à vous recontacter.",
      "Elles ne sont ni vendues, ni transmises à des tiers, et sont conservées uniquement le temps nécessaire au traitement de votre demande.",
      "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données : écrivez à contact@goujonvallee.fr ou appelez le 02 35 60 36 33.",
    ],
  },
  {
    title: "Cookies & mesure d'audience",
    content: [
      "Ce site utilise un outil de mesure d'audience anonymisé afin d'améliorer l'expérience de navigation. Aucune donnée personnelle n'est exploitée à des fins publicitaires.",
    ],
  },
];

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-[#09090B] text-white font-body" data-testid="mentions-legales-page">
      <div className="grain-overlay" />
      <header className="border-b border-white/10 bg-black/40 backdrop-blur-xl">
        <div className="max-w-4xl mx-auto px-6 h-20 flex items-center justify-between">
          <a href="/" data-testid="mentions-back-home" className="flex items-center gap-3 text-xs tracking-[0.2em] uppercase text-zinc-400 hover:text-jaune transition-colors duration-300">
            <ArrowLeft className="w-4 h-4" /> Retour au site
          </a>
          <span className="flex items-center gap-3 uppercase leading-none">
            <Logo size={34} />
            <span>
              <span className="font-brand">Goujon Vallée</span>
              <span className="flex gap-1 mt-1.5">
                <span className="h-1 w-7 bg-jaune" />
                <span className="h-1 w-7 bg-vert" />
              </span>
            </span>
          </span>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-20">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <p className="text-xs tracking-[0.3em] uppercase text-jaune font-bold mb-4">Informations légales</p>
          <h1 className="font-display font-bold uppercase tracking-tight text-3xl sm:text-4xl md:text-5xl leading-tight">
            Mentions légales &amp; RGPD
          </h1>
        </motion.div>

        <div className="mt-16 space-y-14">
          {SECTIONS.map((s, i) => (
            <motion.section
              key={s.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              data-testid={`mentions-section-${i}`}
            >
              <div className="flex gap-2 mb-4">
                <span className="h-1 w-8 bg-jaune" />
                <span className="h-1 w-8 bg-vert" />
              </div>
              <h2 className="font-display font-bold uppercase tracking-tight text-xl sm:text-2xl">{s.title}</h2>
              <div className="mt-4 space-y-3">
                {s.content.map((p, j) => (
                  <p key={j} className="text-sm text-zinc-400 leading-relaxed font-light">{p}</p>
                ))}
              </div>
            </motion.section>
          ))}
        </div>
      </main>
    </div>
  );
}
